import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { NavLink, BrowserRouter, Link, Route, HashRouter } from 'react-router-dom';
import AddHouse from 'features/houseInfo/addHouse';
import ShowRoom from 'features/houseInfo/addRooms';
import RoomInfo from 'features/houseInfo/addRoomInfo';
import ExtraComponents from 'features/houseInfo/extraInformation';
import store from './app/store'
import './index.css'
import MacroInfo from 'features/houseInfo/macroInfo';
import NetworkInfo from 'features/houseInfo/networkInfo';
import ShowPreview from 'features/houseInfo/finalPreview';
import ElInstall from 'features/houseInfo/addelInstall';


function render() {
  const App = require('./app/App').default
  ReactDOM.render(
    <Provider store={store}>
      <HashRouter>
        <Route exact path="/" component={AddHouse} />
        <Route path="/hInfo" component={ShowRoom} />
        <Route path={`/room/:id`} component={RoomInfo} />
        <Route path={`/room/:id/elInstall`} component={ElInstall} />
        <Route path={`/extra`} component={ExtraComponents} />
        <Route path={`/extra/macro`} component={MacroInfo} />
        <Route path={`/extra/network`} component={NetworkInfo} />
        <Route path={`/finalPreview`} component={ShowPreview} />
      </HashRouter>
    </Provider>,
    document.getElementById('root')
  )
}

render()

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./app/App', render)
}